import searchConstants    from './search.constants';
import searchInitialState from './search.state';

function searchReducer(state = searchInitialState, action) {
  switch (action.type) {
    case searchConstants.SEARCH_OPEN:
      state = {
        ...state,
        open: true,
      };
      break;

    case searchConstants.SEARCH_CLOSE:
      state = {
        ...state,
        doors:       searchInitialState.doors,
        information: searchInitialState.information,
        news:        searchInitialState.news,
        open:        false,
        pages:       searchInitialState.pages,
        searched:    false,
      };
      break;

    case searchConstants.SEARCH_REQUEST:
      state = {
        ...state,
        loading:  true,
        searched: true,
      };
      break;

    case searchConstants.SEARCH_SUCCESS:
      state = {
        ...state,
        doors:         action.doors || searchInitialState.doors,
        news:          action.news || searchInitialState.news,
        information:   action.information || searchInitialState.information,
        pages:         action.pages || searchInitialState.pages,
        searchHistory: [
          ...state.searchHistory,
          {
            search:      action.search,
            doors:       action.doors || searchInitialState.doors,
            news:        action.news || searchInitialState.news,
            information: action.information || searchInitialState.information,
            pages:       action.pages || searchInitialState.pages,
          },
        ],
        loading:       false,
      };
      break;

    case searchConstants.SEARCH_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case searchConstants.SEARCH_RESET:
      state = {
        ...state,
        loading:     false,
        doors:       searchInitialState.doors,
        news:        searchInitialState.news,
        information: searchInitialState.information,
        pages:       searchInitialState.pages,
        searched:    false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default searchReducer;